import { forwardRef } from 'react';

import { LineNumbers } from './line-numbers';
import { Content, PlaceHolder } from './editor.styled';

export const Editor = forwardRef((props, ref) => {
  const { onChange, value, cols, maxRows } = props;

  const change = (event) => {
    onChange(event.target.value);
  };

  return (
    <PlaceHolder>
      <Content>
        <LineNumbers rows={maxRows} />
        <textarea ref={ref} cols={cols} rows={maxRows} name="tpl" value={value} onChange={change} style={{ width: `calc(${cols}ch + 3px)` }} />
      </Content>
    </PlaceHolder>
  );
});
